import { useTheme } from "@mui/material";
import { PropsWithChildren } from "react";

import { useLocalStorage } from "../hooks/useLocalStorage";
import DesktopLayoutContext from "./DesktopLayoutContext";

export default function DesktopLayoutContextProvider({ children }: PropsWithChildren<unknown>) {
    const theme = useTheme();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useLocalStorage<boolean>({
        key: "collapseDesktopAppDrawer",
        initialValue: window.innerWidth < theme.breakpoints.values.xl,
    });

    return (
        <DesktopLayoutContext.Provider value={{ isSidebarCollapsed, setIsSidebarCollapsed }}>
            {children}
        </DesktopLayoutContext.Provider>
    );
}
